/**
 * @fileoverview POST handler for the "/data_objects/enable_accounts" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsEnableAccountsCacheKeys } from "./constants";
import type { PostCustomObjectsEnableAccountsProps, PostCustomObjectsEnableAccountsResult } from "./types";

/**
 * Enable the Accounts feature for the current workspace. On success `reactQueryMutationAdapter`
 * invalidates the onboarding_status query (customObjectsEnableAccountsCacheKeys), which refetches
 * and begins polling — no manual refetch wiring.
 */
export const postCustomObjectsEnableAccounts = reactQueryMutationAdapter(
  customObjectsEnableAccountsCacheKeys,
  (_props: PostCustomObjectsEnableAccountsProps): Promise<PostCustomObjectsEnableAccountsResult> => {
    return fetch("/data_objects/enable_accounts", "POST", {}, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
